/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { CustomersData, CustomersService } from './Customers.service';
import { CustomersSearchComponent }  from './CustomersSearch.component';

@Component({
	selector: 'my-Customers',
	template: require('./CustomersList.component.html'),
	providers: [CustomersService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomersListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	CustomersList: CustomersData[];
	newCustomers: CustomersData;
	selectedCustomers: CustomersData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(CustomersSearchComponent) filterComponent: CustomersSearchComponent;

	sortExpression: string = "CustomerID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private CustomersService: CustomersService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newCustomers = new CustomersData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.CustomersService.getAll().subscribe(record => this.CustomersList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getCustomersByPaging();

		/*
		this.CustomersList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getCustomers() {
		this.CustomersService.getAll()
			.subscribe(data => this.CustomersList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on CustomersSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getCustomersByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getCustomersByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getCustomersByPaging();
	}
	
	// Get records by paging
	getCustomersByPaging() {
		this.CustomersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.CustomersList=data.CustomersList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addCustomers() {
		this.CustomersService.addCustomersData(this.newCustomers).subscribe(record => console.log(record));
		this.getCustomers();
	}

	// Updates existing record
	updateCustomers() {
		this.CustomersService.updateCustomersData(this.selectedCustomers).subscribe(record => console.log(record));
		this.getCustomers();
	}

	// Deletes record with specified id
	deleteCustomers(id: string) {
		if (window.confirm('Are you sure you want to delete this Customers?') == true)
		{
			this.CustomersService.deleteCustomers(id)
			.subscribe(data => this.getCustomers(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Customers record deleted successfully...', 'Delete Customers');
					console.log('Customers record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getCustomersByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getCustomersByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getCustomersByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getCustomersByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: CustomersData) {
		this.router.navigate(['/Customers', item.CustomerID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: CustomersData) {
		this.router.navigate(['/Customers/Details', item.CustomerID]);
	}

	// Set record as selected
	SelectCustomers(item: CustomersData) {
		this.selectedCustomers = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/CustomersList.component.ts